import * as Website from '../../Config/Website.js';
import StreamingMeritAnime from './modules/MertiAnime.js';
import Faq from './modules/Faq.js';


const preinit = () => {

}

const init = () => {
  StreamingMeritAnime.init();
  Faq.init();
}

const resize = () => {
  Faq.resize();
}

const resizeW = () => {

}

const scroll = () => {

}

const load = () => {

}

export {
  preinit,
  init,
  resize,
  resizeW,
  scroll,
  load
}
